import { IonButton, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow, IonText } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Meta from '../components/Meta';
import { OptionPages } from '../models/apiModels';
import { Fundraiser, User } from '../models/data';
import { translation } from '../models/translation';
import { fetchAllFundraisers } from '../services/fundraise_service';
import { fetchOptions } from '../services/options_service';
import { fetchRandomOrgPages } from '../services/org_service';
import YouTube from 'react-youtube';


import { AppInfo } from '../models/appInfo';
import './home.scss';

interface HomeProps {
  user?: User | null,
  lan: string
}


const Home: React.FC<HomeProps> = (props) => {
  const siteText = translation();
  const langKey = siteText.lan.replace("/", "");



  const [siteOptions, setSiteOptions] = useState<OptionPages>();
  const [fundraiseList, setFundraiseList] = useState<Fundraiser[]>([])
  const [orgPages, setOrgPages] = useState<any>([]);


  const videoId = ()=>{
    if(langKey==="fr"){
      return "9-A5NOpKHQc"
    }else{
      return "VdFPcuU6K14"
    }
  }

  // Options for the YouTube player
  const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      autoplay: 0,
    },
  };





  useEffect(() => {
    getOptions()
    getOrgPages()
  }, []);


  useEffect(() => {
    fetchAllFundraisers().then(m => {
      setFundraiseList(selectRandomItems(m.message, 3))
    }
    )
  }, [])

  const selectRandomItems = (arr: [any], limit: number) => {
    if (arr.length <= limit) {
      return arr;
    } else {
      const shuffled = arr.sort(() => 0.5 - Math.random());
      return shuffled.slice(0, limit);
    }
  }


  const getOptions = async () => {
    let resp: any = await fetchOptions();
    if (!resp.error) {
      let options: OptionPages = resp.message;
      setSiteOptions(options);
    }
  }

  const getOrgPages = () => {
    fetchRandomOrgPages().then(
      m => {
        if (!m.error) {
          setOrgPages(m.message);
        }
      }
    )
  }



  const colorRiseText = (text: any) => {
    let result = text;
    if (!text) return;


    return { __html: `+${result.replace(/%&(amp;)?([\s\S]*?)&%(amp;)?/g, '<span class="colorize">$2</span>')}` };
  };



  return (<>

    <IonPage className='pageContent'>
      <Meta url={`${window.location.href}`} title={`${AppInfo.slogan}`} shareImage={`${siteOptions?.acf.home_backround_image}`} description={`${AppInfo.slogan}`}></Meta>
      <IonContent>
        <IonGrid>

          <IonRow className='sw_s homeBanner ion-text-center' style={{ backgroundImage: `url(${siteOptions?.acf.home_backround_image ? siteOptions.acf.home_backround_image : ''})` }}>
            <IonCol style={{ padding: 0, width: '100%' }}>
              <IonRow className='homeBannerInner'>
                <IonCol offset="0" sizeXs='12' offsetSm='2' sizeSm="8" offsetMd='2' sizeMd="8">

                  <IonText color='light' >
                    {siteText.lan === "/fr" && <h1 className='sw_mt_lg sw_mb_sm ' dangerouslySetInnerHTML={colorRiseText(siteOptions?.acf.fr.key_phrase_fr)}></h1>}
                    {siteText.lan === "/en" && <h1 className='sw_mt_lg sw_mb_sm ' dangerouslySetInnerHTML={colorRiseText(siteOptions?.acf.en.key_phrase_en)}></h1>}
                    {siteText.lan === "/de" && <h1 className='sw_mt_lg sw_mb_sm' dangerouslySetInnerHTML={colorRiseText(siteOptions?.acf.de.key_phrase_de)}></h1>}
                  </IonText>
                </IonCol>
                <IonCol size='12'></IonCol>

              </IonRow>
            </IonCol>
          </IonRow>

          <IonRow className='sw_sp_md innerBody ion-text-center' >
            <IonCol offsetSm='1' offsetMd="2" sizeSm='10' sizeMd='8' className='ion-margin-top'>
              {orgPages &&
                <IonRow className='homeOrgList sw_sp_sm'>
                  {
                    orgPages.map((item: any, key: any) => {
                      return <IonCol sizeXs='6' sizeSm='3' key={key} className="ion-padding-start ion-padding-end">
                        <Link className='orgOrgIcon' to={`/${langKey}/charities/${item.ID}`}>
                          <IonImg src={item.acf[langKey] ? `${item.acf[langKey].logo}` : ''}></IonImg>
                        </Link>
                      </IonCol>
                    })
                  }

                </IonRow>
              }
              <IonText >
                {siteText.lan === "/en" && <h2 className='h1'>+{siteOptions?.acf.en.value_proposition_header_en}</h2>}
                {siteText.lan === "/fr" && <h2 className='h1'>+{siteOptions?.acf.fr.value_proposition_header_fr}</h2>}
                {siteText.lan === "/de" && <h2 className='h1'>+{siteOptions?.acf.de.value_proposition_header_de}</h2>}
                {siteText.lan === "/fr" && <p className='altText'>{siteOptions?.acf.fr.value_proposition_fr}</p>}
                {siteText.lan === "/en" && <p className='altText'>{siteOptions?.acf.en.value_proposition_en}</p>}
                {siteText.lan === "/de" && <p className='altText'> {siteOptions?.acf.de.value_proposition_de}</p>}
              </IonText>
     
              {!props.user && <IonButton size='large' shape='round' fill='solid' color='primary' mode='ios' routerLink='./signup' className='ion-margin-top' style={{ marginRight: '15px' }}>
                <IonText color='light' >
                  {siteText.createAccBtnTxt}
                </IonText>
              </IonButton>}
              <IonButton size="large" fill="solid" shape='round' color='secondary' mode='ios' routerLink={siteText.lan + '/charities'} className='ion-margin-top '>
                <IonText color='light'>
                  {siteText.toOrganisationBtnTxt}
                </IonText>
              </IonButton>


            </IonCol>
          </IonRow>


          <IonRow className='sw_mt_sm sw_args innerBody'>
            <IonCol sizeMd='10' offsetMd='1' sizeLg='8' offsetLg='2'>
            <div className="youtube-container">
                    <YouTube videoId={videoId()} opts={opts} />
                  </div>
            </IonCol>
            <IonCol size='12' offsetMd='1' sizeMd='10'>
              {siteText.lan === "/fr" && <IonRow className='home_solutions'>
                {siteOptions?.acf.fr.arguments_fr.map(({ argument, icon_link }, key) => {
                  return (
                    <IonCol key={key} sizeXs='12' sizeSm='6' sizeMd='4' >
                      <div className='sw_sp_sm'>
                        <div className="icon_wrapper">
                          <IonImg src={icon_link}></IonImg>
                        </div>
                        <p className='altText'>
                          {argument}
                        </p>

                      </div>
                    </IonCol>
                  )
                })}
              </IonRow>}
              {siteText.lan === "/en" &&
                <IonRow className='home_solutions'>
                  {siteOptions?.acf.en.arguments_en.map(({ argument, icon_link }, key) => {
                    return (
                      <IonCol key={key} sizeXs='12' sizeSm='6' sizeMd='4' >
                        <div className='sw_sp_sm'>
                          <div className="icon_wrapper">
                            <IonImg src={icon_link}></IonImg>
                          </div>
                          <p className='altText'>
                            {argument}
                          </p>

                        </div>
                      </IonCol>
                    )
                  })}
                </IonRow>}
              {siteText.lan === "/de" && <IonRow className='home_solutions'>
                {siteOptions?.acf.de.arguments_de.map(({ argument, icon_link }, key) => {
                  return (
                    <IonCol key={key} sizeXs='12' sizeSm='6' sizeMd='4' >
                      <div className='sw_sp_sm'>
                        <div className="icon_wrapper">
                          <IonImg src={icon_link}></IonImg>
                        </div>
                        <p className='altText'>
                          {argument}
                        </p>

                      </div>
                    </IonCol>
                  )
                })}
              </IonRow>}
            </IonCol>
          </IonRow>
        </IonGrid>
        <Footer></Footer>
      </IonContent>
    </IonPage>
  </>
  );
};

export default Home;
